import { components } from "../../services/api/banking/types";

export const selectorActiveTaxWithholdingAccount = (
  internalAccount: components["schemas"]["InternalAccount"]
) =>
  internalAccount.type === "TaxWithholding" &&
  internalAccount.status === "Active";
